/*!

=========================================================
* Paper Dashboard React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-dashboard-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)

* Licensed under MIT (https://github.com/creativetimofficial/paper-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Dashboard from "views/Dashboard.js";
import Alarms from "views/Alarm.js";
import Errors from "views/Error.js";
import Parts from "views/Part.js";
import Activities from "views/Activity.js";

var routes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    icon: "nc-icon nc-bank",
    component: Dashboard,
    layout: "/admin",
  },

  {
    path: "/parts",
    name: "Parts",
    icon: "nc-icon nc-zoom-split",
    component: Parts,
    layout: "/parts",
  },
  {
    path: "/notifications",
    name: "Alarms",
    icon: "nc-icon nc-bell-55",
    component: Alarms,
    layout: "/admin",
  },
  {
    path: "/user-page",
    name: "Activities",
    icon: "nc-icon nc-zoom-split",
    component: Activities,
    layout: "/admin",
  },
  {
    path: "/tables",
    name: "Errors",
    icon: "nc-icon nc-alert-circle-i",
    component: Errors,
    layout: "/admin",
  },


];
export default routes;
